import { AIAvatarIcon } from '@/features/ai-chat/ui/AIAvatarIcon';
import { LoadingMessageLayout } from '@/features/ai-chat/ui/LoadingMessageLayout';

/** 事業チャットの AI 応答スケルトン */
export const LoadingMessage = () => (
  <LoadingMessageLayout avatar={<AIAvatarIcon className="size-8" />} />
);
